import React from 'react';
import refresh from '_src/assets/images/refresh.svg';
import { RefreshDiv } from './style';

const refreshPage = () => window.location.reload();

function Refresh({ errorBoundery = false }) {
  return (
    <RefreshDiv
      type="button"
      table={errorBoundery}
      onClick={refreshPage}
      aria-label="Refresh page"
    >
      <img src={refresh} alt="" />
    </RefreshDiv>
  );
}

export default Refresh;
